/* tslint:disable */
/* eslint-disable */

export const listRecommendCourseByCompanyWithTag = /* GraphQL */ `
  query ListRecommendCourseByCompanyWithTag(
    $companyId: String!
    $keyword: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecommendCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecommendCourseByCompany(
      companyId: $companyId
      keyword: $keyword
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        companyId
        keyword
        courseId
        course {
          id
          title
          productCode
          description
          thumbnail
          duration
          readable
          release
          tags {
            items {
              tag {
                id
                label
                order
                type
                timestamp
              }
            }
          }
          likes {
            courseId
            count
            timestamp
            createdAt
            updatedAt
          }
          timestamp
          createdAt
          updatedAt
        }
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listTagsByTypeWithCourse = /* GraphQL */ `
  query listTagsByTypeWithCourse(
    $type: String!
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTagFilterInput
    $limit: Int
    $courseLimit: Int
    $nextToken: String
  ) {
    listTagsByType(
      type: $type
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        type
        order
        courses (limit: $courseLimit) {
          items {
            course {
              id
              title
              productCode
              description
              thumbnail
              duration
              readable
              release
              tags {
                items {
                  tag {
                    id
                    label
                    order
                    type
                    timestamp
                  }
                }
              }
              likes {
                courseId
                count
                timestamp
                createdAt
                updatedAt
              }
              timestamp
              createdAt
              updatedAt
            }
          }
          nextToken
        }
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getTagWithCourse = /* GraphQL */ `
  query GetTagWithCourse($id: ID!) {
    getTag(id: $id) {
      id
      label
      type
      order
      courses {
        items {
          id
          courseID
          course {
            id
            title
            productCode
            description
            thumbnail
            duration
            readable
            release
            tags {
              items {
                tag {
                  id
                  label
                  order
                  type
                  timestamp
                }
              }
            }
            likes {
              courseId
              count
              timestamp
              createdAt
              updatedAt
            }
            timestamp
            createdAt
            updatedAt
          }
          tagID
          createdAt
          updatedAt
        }
        nextToken
      }
      timestamp
      createdAt
      updatedAt
    }
  }
`;

export const getCourseWithTag = /* GraphQL */ `
  query getCourseWithTag($id: ID!) {
    getCourse(id: $id) {
      id
      title
      productCode
      description
      thumbnail
      duration
      readable
      release
      tags {
        items {
          tag {
            id
            label
            order
            type
            timestamp
          }
        }
        nextToken
      }
      clips {
        items {
          id
          title
          type
          url
          cover
          content
          order
          duration
          courseId
          plays {
            clipId
            count
            timestamp
            createdAt
            updatedAt
          }
          captions {
            items {
              id
              lang
              label
              url
              default
              clipId
              timestamp
              createdAt
              updatedAt
            }
          }
          timestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      likes {
        courseId
        count
        timestamp
        createdAt
        updatedAt
      }
      timestamp
      createdAt
      updatedAt
    }
  }
`;

export const searchCoursesWithTag = /* GraphQL */ `
  query SearchCoursesWithTag(
    $filter: SearchableCourseFilterInput
    $sort: [SearchableCourseSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCourseAggregationInput]
  ) {
    searchCourses(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        release
        tags {
          items {
            tag {
              id
              label
              type
            }
          }
          nextToken
        }
        clips {
          nextToken
        }
        likes {
          courseId
          count
          timestamp
          createdAt
          updatedAt
        }
        timestamp
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;

export const listTagsWithCourse = /* GraphQL */ `
  query ListTagsWithCourse(
    $id: ID
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTags(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        label
        type
        order
        courses {
          items {
            courseID
            course {
              id
              title
            }
          }
        }
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listCoursesWithItems = /* GraphQL */ `
  query ListCoursesWithItems(
    $id: ID
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCourses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        tags {
          items {
            id
            courseID
            tagID
            tag {
              id
              label
              type
            }
          }
          nextToken
        }
        clips {
          items {
            id
            title
            type
            url
            cover
            content
            order
            duration
            courseId
            captions {
              items {
                id
                lang
                label
                url
                default
                clipId
                timestamp
                createdAt
                updatedAt
              }
            }
            timestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        likes {
          courseId
          count
          timestamp
          createdAt
          updatedAt
        }
        release
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listCourseShowLogByCompanyWithTag = /* GraphQL */ `
  query ListCourseShowLogByCompanyWithTag(
    $companyId: ID!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCourseShowLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourseShowLogByCompany(
      companyId: $companyId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        courseId
        course {
          id
          title
          productCode
          description
          thumbnail
          duration
          readable
          release
          tags {
            items {
              tag {
                id
                label
                type
              }
            }
          }
          likes {
            courseId
            count
          }
          timestamp
          createdAt
          updatedAt
        }
        userName
        userTag
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const onCreateCompanyCourseShowLogWithTag = /* GraphQL */ `
  subscription OnCreateCompanyCourseShowLogWithTag($companyId: String) {
    onCreateCompanyCourseShowLog(companyId: $companyId) {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        tags {
          items {
            tag {
              id
              label
              type
            }
          }
        }
        clips {
          nextToken
        }
        likes {
          courseId
          count
          timestamp
          createdAt
          updatedAt
        }
        release
        timestamp
        createdAt
        updatedAt
      }
      userName
      userTag
      timestamp
      createdAt
      updatedAt
    }
  }
`;

export const createCourseShowLogWithTag = /* GraphQL */ `
  mutation CreateCourseShowLogWithTag(
    $input: CreateCourseShowLogInput!
    $condition: ModelCourseShowLogConditionInput
  ) {
    createCourseShowLog(input: $input, condition: $condition) {
      id
      companyId
      courseId
      course {
        id
        title
        productCode
        description
        thumbnail
        duration
        readable
        tags {
          items {
            tag {
              id
              label
              type
            }
          }
        }
        clips {
          nextToken
        }
        likes {
          courseId
          count
          timestamp
          createdAt
          updatedAt
        }
        release
        timestamp
        createdAt
        updatedAt
      }
      userName
      userTag
      timestamp
      createdAt
      updatedAt
    }
  }
`;

export const listRankingCourseWithTag = /* GraphQL */ `
  query ListRankingCourseWithTag(
    $companyId: String!
    $tagId: String
    $rankingType: String
    $recentRange: Int
    $limit: Int
  ) {
    listRankingCourse(
      companyId: $companyId
      tagId: $tagId
      rankingType: $rankingType
      recentRange: $recentRange
      limit: $limit
    ) {
      company
      count
      items {
        rankingType
        courseId
        course {
          id
          title
          productCode
          description
          thumbnail
          duration
          readable
          release
          tags {
            items {
              tag {
                id
                label
                type
              }
            }
          }
          likes {
            count
          }
          timestamp
          createdAt
          updatedAt
        }
        count
      }
    }
  }
`;

export const searchTagsWithCourses = /* GraphQL */ `query SearchTagsWithCourses(
  $filter: SearchableTagFilterInput
  $sort: [SearchableTagSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTagAggregationInput]
) {
  searchTags(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      label
      type
      order
      courses {
        items {
          course {
            id
          }
        }
        nextToken
        __typename
      }
      timestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
`;
